import { z } from "zod";
import { localDateSchema, moneySchema, quantitySchema, timestampSchema, unitPriceSchema, uuidSchema, } from "../common/primitives.js";
/**
 * Fiyat değişimi kontrolü (Prompt 12 §8; ADR 0012 §13) — **muhasebe kaydı DEĞİLDİR**, bilgi amaçlıdır.
 *
 *  · Yürürlük anındaki stok = en yakın ÖNCEKİ tank okuması − o okumadan yürürlüğe kadar satış + arada teslim alınan.
 *  · Fiyat farkı = stok × (yeni − eski satış fiyatı). Eski fiyat yoksa (ilk fiyat) null.
 *  · Eski fiyattan satış: yürürlükten `priceGraceSeconds` sonra hâlâ eski birim fiyatla gelen satış →
 *    tabanca + anlık görüntü başına BİR alarm (pompa otomasyonu fiyatı almamış).
 */
export const priceChangeTankDetailSchema = z.object({
    tankId: uuidSchema,
    tankNo: z.number().int(),
    lastReadingAt: timestampSchema.nullable(),
    lastReadingVolumeL: quantitySchema.nullable(),
    salesSinceReadingL: quantitySchema,
    deliveredSinceReadingL: quantitySchema,
    stockL: quantitySchema,
});
export const fuelPriceChangeSnapshotSchema = z.object({
    id: uuidSchema,
    companyId: uuidSchema,
    stationId: uuidSchema,
    stationName: z.string(),
    productId: uuidSchema,
    productName: z.string(),
    priceChangeRequestId: uuidSchema,
    requestNo: z.string().nullable(),
    effectiveAt: timestampSchema,
    previousUnitPrice: unitPriceSchema.nullable(),
    newUnitPrice: unitPriceSchema,
    stockL: quantitySchema,
    tankDetails: z.array(priceChangeTankDetailSchema),
    differenceAmount: moneySchema.nullable().describe("stok × (yeni − eski); kuruş. Eski fiyat yoksa null"),
    createdAt: timestampSchema,
});
export const fuelStalePriceAlertSchema = z.object({
    id: uuidSchema,
    stationId: uuidSchema,
    nozzleId: uuidSchema,
    nozzleLabel: z.string(),
    snapshotId: uuidSchema,
    productId: uuidSchema,
    productName: z.string(),
    effectiveAt: timestampSchema,
    firstTransactionAt: timestampSchema,
    firstTransactionId: uuidSchema,
    expectedUnitPrice: unitPriceSchema,
    actualUnitPrice: unitPriceSchema,
    createdAt: timestampSchema,
});
export const fuelPriceChangeReportQuerySchema = z.object({
    companyId: uuidSchema,
    stationId: uuidSchema.optional(),
    from: localDateSchema,
    to: localDateSchema.describe("Dâhil (gün sonuna kadar)"),
});
export const fuelPriceChangeReportSchema = z.object({
    companyId: uuidSchema,
    stationId: uuidSchema.nullable(),
    from: localDateSchema,
    to: localDateSchema,
    snapshots: z.array(fuelPriceChangeSnapshotSchema),
    /** Σ fark tutarı (kuruş). Eski fiyatı olmayan anlık görüntüler toplama girmez. */
    totalDifferenceAmount: moneySchema,
    staleSaleAlerts: z.array(fuelStalePriceAlertSchema),
});
// ── Fiyat dilimleri (vardiya hesabı — Prompt 13) ─────────────────────────────
export const fuelPriceSegmentsQuerySchema = z.object({
    stationId: uuidSchema,
    productId: uuidSchema,
    from: timestampSchema,
    to: timestampSchema,
});
export const fuelPriceSegmentSchema = z.object({
    from: timestampSchema,
    to: timestampSchema,
    unitPrice: unitPriceSchema,
});
export const fuelPriceSegmentsSchema = z.object({
    stationId: uuidSchema,
    productId: uuidSchema,
    from: timestampSchema,
    to: timestampSchema,
    segments: z.array(fuelPriceSegmentSchema),
});
//# sourceMappingURL=price-control.js.map